module.exports = __webpack_public_path__ + "static/media/social_background.39bbd9de.jpeg";